import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {deleteTicketMutation} from './__generated__/deleteTicketMutation.graphql';

const mutation = graphql`
	mutation deleteTicketMutation($input: DeleteTicketInput!, $connections: [ID!]!) {
		deleteTicket(input: $input) {
			clientMutationId
			deletedTicketId @deleteEdge(connections: $connections)
		}
	}
`;

export interface DeleteTicketCommitInput {
	id: string;
	connections: string[];
}

function commit(
	environment: Environment,
	input: DeleteTicketCommitInput,
	onCompleted?: (r: deleteTicketMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	const {connections, id} = input;
	return commitMutation<deleteTicketMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), id},
			connections,
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'deleteTicketMutation'};
